import template from './leave_taken_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportLeaveTakenViewModel
{
	constructor (page)
	{
		this.page = page;
		let firstDay = moment().format('YYYY-MM-01');
		let lastDay = moment().format('YYYY-MM-') + moment().daysInMonth();

		this.show_salary_structure = ko.observable(false);
		this.leave_dep_summary = ko.observableArray();
		this.reportFieldNames = ko.observableArray();
		this.leave_report_new = ko.observableArray();
		this.leave_report_leave_types = ko.observableArray();
		this.leave_report_holiday_types = ko.observableArray();
		this.leave_report_taken_rates = ko.observableArray();

		// Pagination properties
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(10);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records = ko.observable(10);
		
	


		// Base columns for the report
		let baseColumns = ['Employee', 'Employee code', 'ID type', 'ID number', 'Department', 'Company'];
		this.columns = ko.observableArray([...baseColumns]);
		this.visible_columns = ko.observableArray([...baseColumns]);

		// Update columns when data is loaded
		this.leave_report_holiday_types.subscribe((holiday_types) => {
			// Rebuild all columns with the latest data
			this.update_all_columns();
			
			// Ensure holiday columns are visible by default
			if (holiday_types && holiday_types.length > 0) {
				let holiday_columns = holiday_types.map(ht => ht.holiday_type);
				let current_visible = this.visible_columns();
				
				// Add any missing holiday columns to visible columns
				let missing_holiday_columns = holiday_columns.filter(col => !current_visible.includes(col));
				if (missing_holiday_columns.length > 0) {
					this.visible_columns([...current_visible, ...missing_holiday_columns]);
				}
			}
		});

		this.include_archive = ko.observable(false);

		this.current_department_id = ko.observable();
		this.current_company_id = ko.observable();

		this.selected_company = ko.observable();
		this.selected_department = ko.observable();

		this.selected_from_date = ko.observable(new Date(firstDay).toJSON().slice(0, 10));
		this.selected_to_date = ko.observable(new Date(lastDay).toJSON().slice(0, 10));
		this.formatted_date_range = ko.observable();

		// Load saved visible columns
		let saved_visible_columns = localStorage.getItem('leave_taken_report.visible_columns');
		if (saved_visible_columns) {
			this.visible_columns(JSON.parse(saved_visible_columns));
		}

		this.visible_columns.subscribe((newColumns) => {
			localStorage.setItem('leave_taken_report.visible_columns', JSON.stringify(newColumns));
		});

		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.page.updateData();
		});


		this.selected_company.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_company_id(newValue.company_id);
				this.page.updateData();
			}
			else
			{
				this.current_company_id(null);
				this.page.updateData();
			}
		});

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});

		this.end_date_timeout = null;
		this.start_date_timeout = null;

		this.selected_from_date.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.start_date_timeout) 
				clearTimeout(this.start_date_timeout);

			// Set new timeout to wait for user to finish typing or selecting date
			this.start_date_timeout = setTimeout(() => {
				let sd = moment(newValue, "YYYY-MM-DD", true);
				if (!sd.isValid()) return;

				// Update end date to last day of start date month
				let month_end = moment(sd).endOf('month').format('YYYY-MM-DD');
				this.selected_to_date(month_end);
				this.page.updateData();
			}, 500); 
		});

		this.selected_to_date.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.end_date_timeout) 
				clearTimeout(this.end_date_timeout);
			

			// Set new timeout to wait for user to finish typing
			this.end_date_timeout = setTimeout(() => {
				let ed = moment(newValue, "YYYY-MM-DD", true);
				if (!ed.isValid()) return;

				if (newValue.length === 10)
				{
					let sd = moment(this.selected_from_date(), "YYYY-MM-DD", true);
					if (sd.isValid() && ed.isBefore(sd))
					{
						Grape.alerts.alert({ type: 'error', title: tr('Invalid Date Range'), message: tr('End date cannot be before start date') });
						return;
					}
					this.page.updateData();
				}
			}, 1000);
		});

		this.include_archive.subscribe((value) => {
			this.page.updateData();
		});
	}


	page_click (page_number)
	{
		this.current_page_number(page_number);
		this.page.updateData();
	};

	// Helper method to update all columns
	update_all_columns()
	{
		let base_columns = ['Employee', 'Employee code', 'ID type', 'ID number', 'Department', 'Company'];
		if (this.show_salary_structure()) 
			base_columns.push('Salary structure');
		
		let leave_columns = this.leave_report_leave_types().map(lt => lt.leave_type);
		let holiday_columns = this.leave_report_holiday_types().map(ht => ht.holiday_type);
		let rate_columns = this.leave_report_taken_rates().map(tr => tr.taken_rate);
		let note_column = ['Note'];
		
		this.columns([...base_columns, ...leave_columns, ...holiday_columns, ...rate_columns, ...note_column]);
	}

	async download_click(v, e)
{
	
	try {
		// Prepare the data for API request - same as updateReportData but without pagination
		let data = {
			department_id: this.current_department_id(),
			company_id: this.current_company_id(),
			date_start: this.selected_from_date(),
			date_end: this.selected_to_date(),
			include_archive: this.include_archive(),
			// Remove pagination parameters to get all records
			offset: 0,
			limit: 1000  // Very large number to get all records
		};
		
		// Get all the data without pagination
		let res = await Grape.fetches.postJSON('/reports/leave_report_new', data);
		
		if (res.status == 'OK' && res.leave_taken_report.leave_taken_report.length > 0) {
			// Format dates to dd/mm/yyyy for display
			let formatDate = (dateString) => {
				if (!dateString) return '';
				let date = new Date(dateString);
				let day = date.getDate().toString().padStart(2, '0');
				let month = (date.getMonth() + 1).toString().padStart(2, '0');
				let year = date.getFullYear();
				return `${day}/${month}/${year}`;
			};
			
			// Create CSV content with formatted dates
			let date_header = `Report period: ${formatDate(this.selected_from_date())} to ${formatDate(this.selected_to_date())}\n\n`;
			
			// Create header row based on visible columns
			let headers = this.visible_columns().join(',');
			let csv_rows = [headers];
			
			// Process each employee record
			res.leave_taken_report.leave_taken_report.forEach(employee => {
				let row_data = [];
				
				// Add data for each visible column
				this.visible_columns().forEach(column => {
					// Use switch statement for base columns
					switch (column) {
						case 'Employee':
							let name = employee.fullnames;
							row_data.push(`"${name}"`); // Quote to handle commas in names
							break;
						case 'Employee code':
							row_data.push(employee.employee_code || '');
							break;
						case 'ID type':
							row_data.push(employee.id_type || '');
							break;
						case 'ID number':
							row_data.push(employee.id_number || '');
							break;
						case 'Department':
							row_data.push(`"${employee.department || ''}"`);
							break;
						case 'Company':
							row_data.push(`"${employee.company || ''}"`);
							break;
						case 'Salary structure':
							row_data.push(`"${employee.salary_structure || ''}"`);
							break;
						case 'Note':
							row_data.push(`"${employee.note || ''}"`);
							break;
						default:
							// Handle leave type columns, holiday type columns, and taken rate columns
							let valueFound = false;
							
							// Check if this is a leave type
							if (employee.leave_types) {
								for (let i = 0; i < employee.leave_types.length; i++) {
									if (employee.leave_types[i].leave_type === column) {
										row_data.push(employee.leave_taken[i].amount || '0');
										valueFound = true;
										break;
									}
								}
							}
							
							// Check if this is a holiday type
							if (!valueFound && employee.holiday_count) {
								const holiday = employee.holiday_count.find(h => h.holiday_type === column);
								if (holiday) {
									row_data.push(holiday.value || '0');
									valueFound = true;
								}
							}
							
							// Check if this is a taken rate
							if (!valueFound && employee.taken_rates) {
								const rate = employee.taken_rates.find(r => r.taken_rate === column);
								if (rate) {
									row_data.push(rate.value || '0');
									valueFound = true;
								}
							}
							
							// If column wasn't found, add empty cell
							if (!valueFound) {
								row_data.push('');
							}
							break;
					}
				});
				
				// Add complete row to CSV
				csv_rows.push(row_data.join(','));
			});
			
			// Join all rows with newlines
			let csv_string = date_header + csv_rows.join('\n');
			
			// Create and trigger download
			let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
			let link = document.createElement('a');
			
			link.href = URL.createObjectURL(blob);
			link.setAttribute('download', 'leave_taken_report_complete.csv');
			
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else {
			Grape.alerts.alert({ 
				type: 'error', 
				title: tr('No Data'), 
				message: tr('There is no data to download.') 
			});
		}
	} catch (error) {
		console.error('Error downloading report:', error);
		Grape.alerts.alert({ 
			type: 'error', 
			title: tr('Error'), 
			message: tr('An error occurred while downloading the report.') 
		});
	} 
}

	show_report_help()
	{
		Grape.dialog.open('LeaveTakenReportHelp', { employee_id: this.page.bindings.id }, {});
	}
}

class ReportTakenLeavePage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportLeaveTakenViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('LeaveTakenReport'))
			return;

		document.title = tr('Leave Taken Per Employee');
		window.current_page_title(tr('Leave Taken Per Employee'));

		// set settings
		let res = await Grape.fetches.getJSON('/api/setting/report_leave_taken_show_salary_structure', {});
		if (res.value == 'true')
			this.viewModel.show_salary_structure(true);
		else
			this.viewModel.show_salary_structure(false);

		this.updateData()
	}

	async updateData()
	{
		if (
			(this.viewModel.current_company_id() != undefined || this.viewModel.current_department_id()) && 
			this.viewModel.selected_from_date() != '' && this.viewModel.selected_from_date() != undefined &&
			this.viewModel.selected_to_date() != '' && this.viewModel.selected_to_date() != undefined && 
			this.viewModel.selected_to_date() >= this.viewModel.selected_from_date()
		)
			this.updateReportData();
	}

	async updateReportData()
	{
		let data = {
			department_id: this.viewModel.current_department_id(),
			company_id: this.viewModel.current_company_id(),
			date_start: this.viewModel.selected_from_date(),
			date_end: this.viewModel.selected_to_date(),
			include_archive: this.viewModel.include_archive(),
			offset: (this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size(),
			limit: this.viewModel.current_page_size(),
		};


	

		let res = await Grape.fetches.postJSON('/reports/leave_report_new', data);
		if (res.status == 'OK')
		{
			this.viewModel.page_count(Math.ceil(res.leave_taken_report.total / this.viewModel.current_page_size()));
			let start = data.offset + 1;
			let end = Math.min(data.offset + res.leave_taken_report.length, res.leave_taken_report.total);
			this.viewModel.pagination_summary(`Showing ${start} to ${end} of ${res.leave_taken_report.total} entries`);

			if (res.leave_taken_report.leave_taken_report.length > 0)
			{
				// Store the data
				this.viewModel.leave_report_leave_types(res.leave_taken_report.leave_taken_report[0].leave_types);
				this.viewModel.leave_report_holiday_types(res.leave_taken_report.leave_taken_report[0].holiday_count);
				this.viewModel.leave_report_taken_rates(res.leave_taken_report.leave_taken_report[0].taken_rates);
				this.viewModel.leave_report_new(res.leave_taken_report.leave_taken_report);
				console.log('leave report', this.viewModel.leave_report_new())
				
				// Update the columns based on new data
				this.viewModel.update_all_columns();
				
				// Ensure holiday columns are visible by default
				if (res.leave_taken_report.leave_taken_report[0].holiday_count &&
					res.leave_taken_report.leave_taken_report[0].holiday_count.length > 0)
				{
					let holiday_columns = res.leave_taken_report.leave_taken_report[0].holiday_count.map(ht => ht.holiday_type);
					let current_visible = this.viewModel.visible_columns();
					
					// Add any missing holiday columns to visible columns
					let missing_holiday_columns = holiday_columns.filter(col => !current_visible.includes(col));
					if (missing_holiday_columns.length > 0) {
						this.viewModel.visible_columns([...current_visible, ...missing_holiday_columns]);
					}
				}
			}
			else
			{
				this.viewModel.leave_report_leave_types.removeAll();
				this.viewModel.leave_report_holiday_types.removeAll();
				this.viewModel.leave_report_taken_rates.removeAll();
				this.viewModel.leave_report_new.removeAll();
			}
		}
	}
}

export default {
	route: '[/]report/leave_taken',
	page_class: ReportTakenLeavePage,
	template: template,
	template_filename: 'translation/leave_taken_report'
};
